export default "__VITE_ASSET__DWIr4_k6__"